<template>
  <div class="report-ratings">
    <MoreTitle title="研报评级" />
    <div class="edge-padding">
      <VueEcharts :option="option" />
    </div>
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
import { i18nTranslateInit } from '@/utils/utility-lang'
const LEGEND_MAP = [
  { type: '1', label: i18nTranslateInit.useOpenCC('买入'), color: '#FF4C4C' },
  { type: '2', label: i18nTranslateInit.useOpenCC('增持'), color: '#FF9933' },
  { type: '3', label: i18nTranslateInit.useOpenCC('中性'), color: '#3881F7' },
  { type: '4', label: i18nTranslateInit.useOpenCC('减持'), color: '#32C77F7F' },
  { type: '5', label: i18nTranslateInit.useOpenCC('卖出'), color: '#32C77F' }
]

const AXIS_MAP = [
  { key: '12', name: i18nTranslateInit.t('1年内') },
  { key: '6', name: i18nTranslateInit.t('6月内') },
  { key: '3', name: i18nTranslateInit.t('3月内') },
  { key: '1', name: i18nTranslateInit.t('1月内') }
]
export default {
  components: { VueEcharts },
  inject: ['theme'],
  data() {
    return {
      data: [],
      useOpenCC: i18nTranslateInit.useOpenCC
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    categoricalData() {
      let result = this.data
      // 按type分类
      result = result.reduce((res, curr) => {
        if (res[curr.type]) {
          res[curr.type].push(curr)
        } else {
          res[curr.type] = [curr]
        }
        return res
      }, {})
      // 将 period 排序
      LEGEND_MAP.forEach((item) => {
        if (result[item.type]) {
          const orderData = AXIS_MAP.map((item1) => {
            const find = result[item.type].find((item2) => item2.period.toString() === item1.key)
            return find ? find : { period: item1.key, number: '0', type: item.type }
          })
          result[item.type] = orderData
        } else {
          result[item.type] = AXIS_MAP.map((item1) => {
            return { period: item1.key, number: '0', type: item.type }
          })
        }
      })
      return result
    },
    option() {
      return {
        title: {
          subtext: this.useOpenCC('单位(家)'),
          top: -10,
          right: 0
        },
        legend: {
          itemHeight: 8,
          itemWidth: 8,
          icon: 'rect',
          top: 0,
          left: 0,
          textStyle: {
            color: this.theme['--font-color-5'],
            fontSize: this.$i18n.lang === 'en-us' ? 11 : 13
          }
        },
        grid: {
          left: 0,
          right: 0,
          top: 40,
          bottom: 10,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              fontSize: 13,
              color: this.theme['--font-color-5']
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.theme['--border-color-4']
              }
            },
            data: ['1年内', '6月内', '3月内', '1月内'].map((r) => this.$t(r))
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 13,
              color: this.theme['--font-color-5']
            },
            minInterval: 1,
            splitLine: {
              show: true,
              lineStyle: {
                color: this.theme['--border-color-4']
              }
            },
            splitNumber: 3
          }
        ],
        series: LEGEND_MAP.map((item) => {
          return {
            name: item.label,
            type: 'bar',
            barWidth: 21,
            stack: 'rate',
            itemStyle: {
              color: item.color
            },
            data: this.categoricalData[item.type].map((item) => item.number)
          }
        })
      }
    }
  },
  created() {
    this.getInvestData()
  },
  methods: {
    async getInvestData() {
      const api = {
        hk: this.$api.f10.hk + '/summary/invest-statistics',
        us: this.$api.f10.us + '/summary/invest-statistics'
      }
      const res = await this.$post(api[this.market], {
        symbol: this.symbol
      })
      // 只要5种type
      const typsList = LEGEND_MAP.map(({ type }) => type)
      this.data = res.data?.filter(({ type }) => typsList.includes(type))
    }
  }
}
</script>

<style lang="scss" scoped>
.report-ratings {
  background: var(--bg-color-2);
}
</style>
